/**
 * BrandMark — the student-facing logo, brand-aware.
 *
 * Resolution order (via useBranding):
 *   1. partner / platform logo image  (white-label subdomains, testmug, …)
 *   2. brand name wordmark            (brand set but no logo uploaded)
 *   3. FresherBot logo                (default deployment, no branding)
 *
 * Use this anywhere a student sees "the app's logo" — headers, exam
 * chrome, practice runner — so partner students never see FresherBot.
 */
import { C } from './dashboard/theme';
import { useBranding } from '../../../shared/hooks/useBranding';
import { FresherbotLogo } from '../../../shared/components/FresherbotLogo';

export function BrandMark({ height = 26, maxWidth = 180 }: { height?: number; maxWidth?: number }) {
  const { logoUrl, name, loaded, logoScale } = useBranding();
  const h = Math.round(height * logoScale); // brand logo-size control
  // Until branding resolves, render an empty placeholder (reserving height so
  // layout doesn't jump) — this prevents the FresherBot logo from flashing on
  // white-label deployments before the brand is known.
  if (!loaded) {
    return <span aria-hidden style={{ display: 'inline-block', height: h, width: 1 }} />;
  }
  if (logoUrl) {
    return <img src={logoUrl} alt={name ?? 'Logo'} style={{ height: h, width: 'auto', maxWidth, objectFit: 'contain' }} />;
  }
  if (name) {
    return <span style={{ fontWeight: 800, letterSpacing: '-0.02em', color: C.ink, fontSize: Math.round(h * 0.62) }}>{name}</span>;
  }
  return <FresherbotLogo height={Math.round(h * 0.85)} />;
}
